export enum UserGeneralFormFieldEnum {
    NAME = 'name',
    EMAIL = 'email',
    PHONE = 'phone',
    TITLE = 'title',
    ROLE = 'role'
}